// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { inventoryController } from "../../../game_theme/flow_fb/flowController";
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfDialogs } from "../../framework/dialogs/tgfDialogs";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { DialogSettings, PowerUpSettings } from "../../settings/Settings";
import { SoundManager } from "../../settings/SoundManager";
import { AngryAnalytics } from "../Analytics/Analytics";
import { s_black_square, s_popup_darkblue_rect, s_popup_top, s_popup_bottom, s_btn_green, s_icon_movie, s_btn_red_small, s_button_rectangle_white, s_buttonpowerbg, s_buttonpower_disabled } from "../AssetDefinitions/ImageDefinitions";
import { EventSystem } from "../Events/EventSystem";
import { Events } from "../Events/Events";
import { playController } from "../gameController";
import { LoadingOverlay } from "./LoadingOverlay";
tgfSettings.dialogDefaults.PowerupRefillDialog = {
    width: 800,
    height: 550,
    text: "FREE_POWERUPS_TEXT",
    noText: "BTN_NO_THANKS",
    yesText: "BTN_FREE_REFILL",
    headerText: "FREE_POWERUPS_HEADER",
    font: DialogSettings.textFont,
    yesButtonFont: DialogSettings.buttonFont,
    noButtonFont: DialogSettings.buttonFontSmall,
    components: [] // The additional components to add
};
export var PowerupRefillDialog = function (properties) {
    "use strict";
    this.name = "PowerupRefillDialog"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.PowerupRefillDialog);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
    this.onDisconnect = this.close.bind(this, false);
    EventSystem.subscribe(Events.DISCONNECTED, this.onDisconnect);
};
// Inherit the base dialog
tgfDialogs.inherit(PowerupRefillDialog, DialogBase);
PowerupRefillDialog.prototype.doPrepare = function () {
    "use strict";
    var self = this;
    this.transparentBlack = new ComponentButton({
        x: tgfGraphics.areaWidth / 2 + -100,
        y: tgfGraphics.areaHeight / 2 + -100,
        xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
        yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
        alpha: 0.7,
        image: s_black_square
    });
    this.addComponent(this.transparentBlack);
    this.background = new ComponentPicture({
        image: s_popup_darkblue_rect,
        createFromSlices: true,
        sliceMarginsArray: [55, 55, 55, 55],
        width: this.width,
        height: this.height,
        x: -(this.width / 2) + 100,
        y: -(this.height / 2) + 100
    });
    this.transparentBlack.addComponent(this.background);
    this.headerBackground = new ComponentPicture({ image: s_popup_top, x: tgfGraphics.areaWidth / 2, y: -285 + tgfGraphics.areaHeight / 2 });
    this.addComponent(this.headerBackground);
    this.addComponent(new ComponentPicture({ image: s_popup_bottom, x: tgfGraphics.areaWidth / 2, y: 255 + tgfGraphics.areaHeight / 2 }));
    this.headerLabel = new ComponentLabel({
        text: tgfDictionary.getText(this.headerText),
        font: this.font,
        y: 4
    });
    this.headerBackground.addComponent(this.headerLabel);
    this.label = new ComponentLabel({
        text: tgfDictionary.getText(this.text),
        x: 100,
        y: -200 + 100,
        width: this.background.width * 0.9,
        splitLines: true,
        font: this.font
    });
    this.transparentBlack.addComponent(this.label);
    this.yesButton = new ComponentButton({
        image: s_btn_green,
        icon: s_icon_movie,
        iconPosition: "right",
        iconXScale: 0.5,
        iconYScale: 0.5,
        text: tgfDictionary.getText(this.yesText),
        x: 100,
        y: 75 + 100,
        onClick: function () {
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
            AngryAnalytics.reportPreGamePowerupRefresh(inventoryController.getFilledPowerUps());
            self.onAdSuccess.call(self);
        },
        fontUp: this.yesButtonFont
    });
    this.transparentBlack.addComponent(this.yesButton);
    this.noButton = new ComponentButton({
        image: s_btn_red_small,
        text: tgfDictionary.getText(this.noText),
        x: 100,
        y: 190 + 100,
        onClick: function () {
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
            self.close(true);
        },
        fontUp: this.noButtonFont,
        fitToBox: false
    });
    this.transparentBlack.addComponent(this.noButton);
    this.initPowerups();
    if (playController) {
        playController.activePowerupRefillDialog = this;
    }
    this.loader = new LoadingOverlay({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
};
PowerupRefillDialog.prototype.initPowerups = function () {
    this.powerupBar = new ComponentPicture({
        image: s_button_rectangle_white,
        xScale: 1.8,
        yScale: 1.2,
        x: tgfGraphics.areaWidth / 2,
        y: 300,
    });
    this.powerupImages = [];
    this.powerupBackgrounds = [];
    this.whiteSpheres = [];
    var powerups = inventoryController.getPowerUpSlots();
    var spacing = 130;
    var leftY = -spacing * ((powerups.length - 1) / 2);
    for (var i = 0; i < powerups.length; i++) {
        this.whiteSpheres[i] = new ComponentPicture({
            image: s_buttonpowerbg,
            x: leftY + spacing * i,
            xScale: 1.07,
            yScale: 1.07
        });
        this.powerupBar.addComponent(this.whiteSpheres[i]);
        var bgImg;
        if (powerups[i].powerUp != -1) {
            bgImg = PowerUpSettings.options[powerups[i].powerUp].bgImg;
        }
        else {
            bgImg = s_buttonpower_disabled;
        }
        this.powerupBackgrounds[i] = new ComponentPicture({
            image: bgImg,
            xScale: 1.1,
            yScale: 1.1
        });
        this.whiteSpheres[i].addComponent(this.powerupBackgrounds[i]);
        if (powerups[i].powerUp != -1) {
            this.powerupImages[i] = new ComponentPicture({
                image: PowerUpSettings.options[powerups[i].powerUp].image,
                xScale: 1.1,
                yScale: 1.1
            });
            this.whiteSpheres[i].addComponent(this.powerupImages[i]);
        }
    }
    this.addComponent(this.powerupBar);
};
PowerupRefillDialog.prototype.onAdSuccess = function () {
    if (inventoryController.getCooldown() <= 0) {
        inventoryController.resetCooldown();
        inventoryController.unlockAllPowerUps();
        playController.uiController.reinitializePowerUpUI();
    }
    this.close(true);
};
PowerupRefillDialog.prototype.close = function (callOnClose) {
    this.hide();
    this.free();
    EventSystem.unsubscribe(Events.DISCONNECTED, this.onDisconnect);
    if (playController) {
        playController.activePowerupRefillDialog = null;
    }
    if (this.onClose && callOnClose) {
        this.onClose();
    }
};
PowerupRefillDialog.prototype.toggleInput = function (enable) {
    if (enable) {
        this.activate();
    }
    else {
        this.deactivate();
    }
};
